import { render, staticRenderFns } from "./Construction.vue?vue&type=template&id=1d35a4bc&"
import script from "./Construction.vue?vue&type=script&lang=ts&"
export * from "./Construction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports